exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.automation-create-component[data-v-3e5ee10f] {\n  position: relative;\n}\n", ""]);

// exports
